__turbopack_context__.v({
  "chevron": "MarketingSelectorButton-module-scss-module__rzFIhW__chevron",
  "imageContainer": "MarketingSelectorButton-module-scss-module__rzFIhW__imageContainer",
  "label": "MarketingSelectorButton-module-scss-module__rzFIhW__label",
  "marketingSelectorButton": "MarketingSelectorButton-module-scss-module__rzFIhW__marketingSelectorButton",
  "teamImage": "MarketingSelectorButton-module-scss-module__rzFIhW__teamImage",
});
